import { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './GoToTopNavigation.module.scss';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import UpArrow from 'ui/icons/icon_up-arrow.svg';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

export interface GoToTopNavigationProps {
	className?: string;
	scrollYThreshold?: number;
	title: string;
}

export const UI_GoToTopNavigation = ({ className, scrollYThreshold, title }: GoToTopNavigationProps) => {
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		const handleScroll = () => {
			setVisible(window.scrollY > (scrollYThreshold || 300));
		};
		window.addEventListener('scroll', handleScroll, { passive: true });
		handleScroll();
		return () => window.removeEventListener('scroll', handleScroll);
	}, [scrollYThreshold]);

	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<CludoComment>
			<button
				type="button"
				className={classNames(styles.GoToTopNavigation, { [styles.isHidden]: !visible }, className)}
				onClick={handleClick}
				aria-label={title}
			>
				<UI_Icon className={styles.GoToTopNavigation_icon} size="lg" style="circleLight">
					<UpArrow />
				</UI_Icon>
				<span className={styles.GoToTopNavigation_text}>{title}</span>
			</button>
		</CludoComment>
	);
};
